// countriesDuck.js

import { axiosGet } from '../utils/AxiosApi';
import { URL } from '../utils/Constants';

// Action Types
const GET_COUNTRIES_REQUEST = 'countries/GET_COUNTRIES_REQUEST';
const GET_COUNTRIES_SUCCESS = 'countries/GET_COUNTRIES_SUCCESS';
const GET_COUNTRIES_FAILURE = 'countries/GET_COUNTRIES_FAILURE';

// Initial State
const initialState = {
  loading: false,
  countries: [],
  error: null
};

// Reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_COUNTRIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case GET_COUNTRIES_SUCCESS:
      return {
        ...state,
        loading: false,
        countries: action.payload,
        error: null
      };

    case GET_COUNTRIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
}

// Action Creators
export const getCountriesRequest = () => ({
  type: GET_COUNTRIES_REQUEST
});

export const getCountriesSuccess = (countries) => ({
  type: GET_COUNTRIES_SUCCESS,
  payload: countries
});

export const getCountriesFailure = (error) => ({
  type: GET_COUNTRIES_FAILURE,
  payload: error
});

// Thunk Action
export const fetchCountries = () => (dispatch, getState) => {
  dispatch(getCountriesRequest());

  axiosGet(
    URL.countryUrl,
    (response) => {
      if (response.data.success) {
        const countriesList = response.data.data.items.map((country) => ({
          label: country.name,
          value: country.code
        }));
        dispatch(getCountriesSuccess(countriesList));
      } else {
        dispatch(getCountriesFailure(response.data.message));
        // You can still keep the swal notification here if needed
        // swal('Error', response.data.message, 'error');
      }
    },
    (error) => {
      dispatch(getCountriesFailure(error.message));
    }
  );
};

// Selectors
export const selectCountries = (state) => state.countries.countries;
export const selectCountriesLoading = (state) => state.countries.loading;
export const selectCountriesError = (state) => state.countries.error;
